import * as React from "react";
import { Link } from "react-router-dom";
import { BlockRow } from "../../../components/atoms/BlockRow";
import { MainSection, PageHeader } from "../../../components/atoms/MainSection";
import {
  BreadcrumbItem,
  Breadcrumbs,
} from "../../../components/general/Breadcrumbs";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceSectionsSettingsPage, {
  SectionsSettingsPageProps,
} from "../../../hocs/enhanceSectionsSettingsPage";
import { createAddURLAction } from "../../../hooks/useDetermineURLAction";
import SectionInterface from "../../../interfaces/SectionInterface";
import { TeacherForm } from "./forms/TeacherForm";
import styles from "./styles.scss";

// Main hooks
type UseSectionSettingsTeacherNewProps = {
  sectionId: string;
};
const useSectionSettingsTeacherNew = ({
  sectionId,
}: UseSectionSettingsTeacherNewProps) => {
  const urlAction = createAddURLAction();

  const teacherFormProps = {
    urlActionType: urlAction.type,
    editingTeacher: undefined,
  };

  const breadcrumbProps = React.useMemo<BreadcrumbItem[]>(
    () => [
      { label: "講師管理", url: `/sections/${sectionId}/settings/teachers` },
      { label: `講師の登録` },
    ],
    [urlAction, sectionId],
  );

  return {
    teacherFormProps,
    breadcrumbProps,
  };
};

// Main Component
type Props = SectionsSettingsPageProps &
  OutletContextProps & {
    section: SectionInterface;
  };
const SectionsSettingsTeacherNewPage_ = (props: Props) => {
  React.useEffect(() => {
    props.setActiveMenu("teachers");
  }, []);
  const section = props.section;
  const { teacherFormProps, breadcrumbProps } = useSectionSettingsTeacherNew({
    sectionId: section.id,
  });

  return (
    <>
      {/* パンくずの上下マージンは「戻る」リンク（BackLink）と揃えて 2rem に統一する */}
      <div className="my-8">
        <Breadcrumbs items={breadcrumbProps}>
          {(item, isLast) =>
            isLast || !item.url ? (
              item.label
            ) : (
              <Link to={item.url}>{item.label}</Link>
            )
          }
        </Breadcrumbs>
      </div>
      <BlockRow>
        <MainSection>
          <div className={styles.mainSectionWrapper}>
            <PageHeader>講師の登録</PageHeader>
            <p className={styles.description}>
              校舎に所属する指導者・講師の登録ができます。
            </p>
            <TeacherForm sectionId={section.id} {...teacherFormProps} />
          </div>
        </MainSection>
      </BlockRow>
    </>
  );
};

const pageInfo = {
  title: "講師登録",
};

export const SectionsSettingsTeacherNewPage = enhanceSectionsSettingsPage(
  SectionsSettingsTeacherNewPage_,
  pageInfo,
  ["teachers"],
);
